import { HttpHeaders } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { AnvandareDTO } from "~app/common/models/anvandare/AnvandareDTO";
import { TypeAheadDTO } from "~app/common/models/common/TypeAheadDTO";
import { Betalningsmetod, KontaktDTO } from "~app/common/models/kontakter/KontaktDTO";
import { Viol3AktorDto } from "~app/common/models/kontakter/Viol3AktorDto";
import { UpdatedVirkesLeverantorMomsValuesDTO } from "~app/common/models/virkeskop/v2/UpdatedVirkesLeverantorMomsValuesDTO";
import { ApiClientService } from "~app/common/services/api-client.service";

@Injectable({
    providedIn: "root"
})
export class LeverantorService {
    private readonly apiClientService = inject(ApiClientService);

    private static readonly juridiskPerson = "Juridisk person";

    createLime(id: number): Observable<any> {
        const command = { id: id };
        return this.apiClientService.post(`virkesleverantor/exportlime`, command);
    }

    getBetalningsmetoder() {
        return [
            { id: Betalningsmetod.Bankkonto,
                namn: "Bankkonto" },
            { id: Betalningsmetod.Bankgiro,
                namn: "Bankgiro" },
            { id: Betalningsmetod.Postgiro,
                namn: "Plusgiro" }
        ];
    }

    getCreateLeverantor(guid?: string): Observable<KontaktDTO> {
        return this.apiClientService.get<KontaktDTO>("virkesleverantor/create/kontakt", false, { guid: guid });
    }

    getGrupperingar() {
        return [
            { id: "Skogsägare leverantör",
                namn: "Skogsägare leverantör" },
            { id: "Ombud",
                namn: "Ombud" }
        ];
    }

    getIntressenter(id: number): Observable<AnvandareDTO[]> {
        return this.apiClientService.get<AnvandareDTO[]>(`virkesleverantor/${id}/intressenter`, false);
    }

    getKlassningar() {
        return [
            { id: "A",
                namn: "A - Ambassadör" },
            { id: "B",
                namn: "B - Intressanta" },
            { id: "C",
                namn: "C - Övriga" },
            { id: "D",
                namn: "D - Vill ej bli kontaktade" }
        ];
    }

    getLeverantor(id: number): Observable<KontaktDTO> {
        return this.apiClientService.get<KontaktDTO>(`virkesleverantor/${id}/kontakt`, false);
    }

    getMomssatser() {
        return [
            { id: "",
                namn: "" },
            { id: "0",
                namn: "0 – Moms, 0%" },
            { id: "1",
                namn: "1 – Moms, 25%" }
        ];
    }

    getPosition3IntnrOptionsOptions() {
        return [
            { id: null,
                namn: "" },
            { id: 2,
                namn: "2" },
            { id: 3,
                namn: "3" },
            { id: 4,
                namn: "4" },
            { id: 5,
                namn: "5" },
            { id: 6,
                namn: "6" },
            { id: 7,
                namn: "7" },
            { id: 8,
                namn: "8" },
            { id: 9,
                namn: "9" }
        ];
    }

    getUtboAbo() {
        return [
            { id: "Okänd",
                namn: "Okänd" },
            { id: "Utbo",
                namn: "Utbo" },
            { id: "Åbo",
                namn: "Åbo" }
        ];
    }

    getViol3AktorData(orgnr: string): Observable<Viol3AktorDto[]> {
        return this.apiClientService.get<Viol3AktorDto[]>(`virkesleverantor/aktor/${orgnr}`, false);
    }

    searchAnvandare(search: string): Observable<TypeAheadDTO[]> {
        return this.apiClientService.post<any, TypeAheadDTO[]>(`virkeskop/kopare/typeahead`, JSON.stringify(search), false, null, this.getHeader());
    }

    searchOrgnr(search: string): Observable<TypeAheadDTO[]> {
        return this.apiClientService.get<TypeAheadDTO[]>(`virkesleverantor/orgnr/typeahead/${search}`, false);
    }

    updateAndGetChangesForViesValidation(virkesleverantorid: number, momsnummer: string): Observable<UpdatedVirkesLeverantorMomsValuesDTO> {
        return this.apiClientService.get<UpdatedVirkesLeverantorMomsValuesDTO>("virkesleverantor/updateMomsInfo", false, {
            leverantorId: virkesleverantorid,
            momsnummer: momsnummer
        });
    }

    private getHeader(): HttpHeaders {
        const headers = new HttpHeaders();
        return headers.append("content-type", "application/json");
    }
}
